import PersonalInformationProcessingForm from './personal-information-processing-form';

export default PersonalInformationProcessingForm;
